import React, { useEffect } from 'react';
import EditPopUpCore from './EditPopUpCore';

/*
This component is used to render the edit pop up window of a general component
*/
const EditPopUpGeneral = (props) => {
  const { editor, savedPageClicked, selectedPage, selectedProject } = props;

  const [init, setInit] = React.useState(false);
  const [clickedEdit, setClickedEdit] = React.useState(false);

  // This useEffect adds to the grapesJs commands the `open edit link pop up window` command
  useEffect(() => {
    if (init === false && editor.BlockManager !== undefined) {
      editor.Commands.add('edit-data-element-general', {
        run() {
          setClickedEdit(true);
        }
      });
      setInit(true);
    }
  },[selectedProject,selectedPage]);

  return (
    <EditPopUpCore
      editor={editor}
      savedPageClicked={savedPageClicked}
      selectedPage={selectedPage}
      selectedProject={selectedProject}
      clickedEdit={clickedEdit}
      setClickedEdit={setClickedEdit}
    />
  );
};
export default EditPopUpGeneral;
